import Vue from 'vue'
import './plugins/vuetify'
import './plugins/filters'
import './plugins/csv'
import App from './App.vue'
import router from './router'
import axios from './backend'
import store from './store'

import { mapGetters } from 'vuex'

import L from 'leaflet'
delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

Vue.config.productionTip = false

new Vue({
  router,
  axios,
  store,
  render: h => h(App),
  computed: {
    ...mapGetters({ currentUser: 'currentUser', vueFrontendConfig: 'vueFrontendConfig' })
  },
  methods: {
    loginRequired () {
      if (!this.currentUser && this.$route.path !== '/') {
        this.$router.push('/?redirect=' + this.$route.path)
      }
    },
    loadFrontendConfig (allowFromCache) {
      const defaultBaseURL = `${window.location.origin}/api`
      const configURL = process.env.NODE_ENV === 'production' ? '/ui/frontend_config.json' : '/frontend_config.json'
      if (allowFromCache && this.vueFrontendConfig !== undefined) {
        this.$http.defaults.baseURL = this.vueFrontendConfig.api !== undefined ? this.vueFrontendConfig.api : defaultBaseURL
      } else {
        this.$http
          .get(`${window.location.origin}${configURL}`)
          .then(response => {
            var jsonResponseData
            try {
              jsonResponseData = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
            } catch (e) {
              jsonResponseData = { 'error': `${e}` }
            }
            this.$store.dispatch('configureVue', jsonResponseData)
            this.$http.defaults.baseURL = response.data.api !== undefined ? response.data.api : defaultBaseURL
          })
          .catch((err) => {
            // eslint-disable-next-line
            console.log(`Error(${err} - reading frontend_config.json)`)
            this.$http.defaults.baseURL = defaultBaseURL
          })
      }
    }
  },
  created () {
    this.loadFrontendConfig(false)
    this.loginRequired()
  }
}).$mount('#app')
